import { http } from 'utils'

// Source mutation imports.
import {
  SET_SOURCE, SET_FIRST_SOURCE
} from 'vx/mutations'

import initialSourceState from 'vx/state/booking/source'

// Source state.
const state = {
  source: initialSourceState(),
  firstSource: null
}

// Source state getters.
const getters = {
  //
}

// Source actions.
const actions = {
  /**
   * Get source for a booking.
   *
   * @return Promise
   */
  getBookingSource ({ commit }, id) {
    return http.get(`bookings/${id}/source`)
      .then((response) => {
        commit(SET_SOURCE, response.data.source)
        commit(SET_FIRST_SOURCE, response.data.first_source)
        return response
      })
  },

  updateBookingSource ({ commit }, { id, payload }) {
    return http.post(`bookings/${id}/source`, payload)
      .then((response) => {
        commit(SET_SOURCE, response.data.source)
        commit(SET_FIRST_SOURCE, response.data.first_source)
        return response
      })
  }
}

// Source state mutations.
const mutations = {
  /**
   * Set source
   */
  [SET_SOURCE] (state, source) {
    state.source = source
  },

  [SET_FIRST_SOURCE] (state, source) {
    state.firstSource = source
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
